import Error from "../app-shell/Error";
import Sidebar from "../app-shell/Sidebar";
import React from "react";

// TODO Improved design/implementation
const ErrorPage: React.FC = () => {
  return (
    <div className="flex h-screen">
      <Sidebar />
      <Error />
    </div>
  );
};

export default ErrorPage;
